import {OnShowError} from "@baseTypes/base";
import {BASE_TRACK_API_URL} from "@constants/config";
import {apiRequestWithAuth} from "@helpers/query/apiRequestWithAuth";
import {VoyageStatusSingleVoyage} from "@containers/singleVoyage/types/voyage";
import {
    DataGetByIdSingleVoyage,
    DataSingleVoyages,
    IDataPaginationSimpleSingleVoyages,
    IPropsGetByIdSingleVoyage,
    IPropsGetPaginationSimpleSingleVoyages,
    IPropsGetSingleVoyages,
    IServerDataPaginationSimpleSingleVoyages
} from "@containers/singleVoyage/fetchingData/types";
import {serialize} from "@helpers/query/serialize";


const BASE_URL = `${BASE_TRACK_API_URL}/v1/accounts`

export const getSingleVoyagesApi = async (
    {
        params,
        onError,
        voyageStatuses,
    }: {
        params: IPropsGetSingleVoyages,
        onError?: OnShowError,
        voyageStatuses?: VoyageStatusSingleVoyage[]
    }
): Promise<DataSingleVoyages> => {
    const url = `${BASE_URL}/${params.accountId}/single-voyages`
    const res = await apiRequestWithAuth<DataSingleVoyages>({
        url,
        options: {
            method: "GET",
        },
        onError
    });

    if (!voyageStatuses?.length) {
        return res;
    }

    return res?.filter((singleVoyage) => voyageStatuses.includes(singleVoyage.voyageStatus));

}

export const getSingleVoyagesPaginationApi = async (
    {
        params,
        onError,
        voyageStatuses,
    }: {
        params: IPropsGetPaginationSimpleSingleVoyages,
        onError?: OnShowError,
        voyageStatuses?: VoyageStatusSingleVoyage[]
    }
): Promise<IDataPaginationSimpleSingleVoyages> => {
    const {
        perPage,
        page,
    } = params

    const limit = perPage > 0 ? perPage : undefined
    const offset = perPage > 0 ? perPage * (page - 1) : undefined
    const sort = params?.direction && params?.order ? `${params.order},${params.direction.toLowerCase()}` : undefined
    const voyageStatusesStr = voyageStatuses && voyageStatuses?.length ? `&${voyageStatuses.map((status)=>`status=${status}`).join('&')}` : ''
    const url = `${BASE_URL}/${params.accountId}/single-voyages/list?` + serialize({
        limit,
        offset,
        sort,
        ...params?.searchValue?.length >= 1 ? {title: params.searchValue} : {},
    }) + voyageStatusesStr

    const res = await apiRequestWithAuth<IServerDataPaginationSimpleSingleVoyages>({
        url,
        options: {
            method: "GET",
        },
        onError
    });

    if (!voyageStatuses?.length) {
        return {
            rows: res?.data,
            totalPage: perPage > 0 ? Math.ceil(res.total / (res.limit ?? perPage)) : 1
        }
    }

    return {
        rows: res?.data,
        totalPage: perPage > 0 ? Math.ceil(res.total / (res.limit ?? perPage)) : 1
    }

}

export const getSingleVoyageByIdApi = async (
    {accountId, voyageId}: IPropsGetByIdSingleVoyage,
    onError?: OnShowError
): Promise<DataGetByIdSingleVoyage> => {
    const url = `${BASE_URL}/${accountId}/single-voyages/${voyageId}`
    return await apiRequestWithAuth<DataGetByIdSingleVoyage>({
        url,
        options: {
            method: "GET",
        },
        onError
    });
}